var communities = {};

communities = {
  sing: "Untergemeinschaft",
  plu: "Untergemeinschaften",
  h_plu: "Übersicht - Untergemeinschaften",
}

export default communities;